import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import * as Ui from './Breadcrumbs.styles';

const Breadcrumbs = ({ items }) => {
  const { t } = useTranslation('app');

  if (!items?.length) return null;

  return (
    <Ui.Nav aria-label={t('breadcrumb')}>
      <Ui.List>
        {items.map((item, index) => {
          const isCurrent = index === items.length - 1;

          return (
            <Ui.Item key={item.key || item.to || 'current'}>
              {index > 0 && <Ui.Separator aria-hidden="true">›</Ui.Separator>}
              {item.to && !isCurrent ? (
                <Ui.CrumbLink as={Link} to={item.to}>
                  {item.label}
                </Ui.CrumbLink>
              ) : (
                <Ui.Current aria-current={isCurrent ? 'page' : undefined}>{item.label}</Ui.Current>
              )}
            </Ui.Item>
          );
        })}
      </Ui.List>
    </Ui.Nav>
  );
};

Breadcrumbs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.node.isRequired,
      to: PropTypes.string,
    }),
  ).isRequired,
};

export default Breadcrumbs;
